module.exports = __webpack_public_path__ + "img/BASEBALL CAP LIME.5a94800.svg";